// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PopularArticles_wrapper__T90ly","title":"PopularArticles_title__o3T_e","subtitle":"PopularArticles_subtitle__TCs0E","articles":"PopularArticles_articles__W9SjF"};